<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/sampling/plan/page" getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('chouyangfanganbianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('chouyangfanganmingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{ $t('sousuo') }}
						</el-button>
						<el-button @click="yt.clear()">{{ $t('chongzhi') }}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 抽样类型 -->
			<template #chouyangleixing="scope">
				<span v-if="scope.row.samplingType == 1">{{ $t('chouyangfangan') }}</span>
				<span v-if="scope.row.samplingType == 2">{{ $t('100%chouyang') }}</span>
				<span v-if="scope.row.samplingType == 3">{{ $t('gudingchouyang') }}</span>
				<span v-if="scope.row.samplingType == 4">{{ $t('anbaifenbichouyang') }}</span>
			</template>
			<!-- 严格度 -->
			<template #yangedu="scope">
				<span v-if="scope.row.level == 1">{{ $t('zhengchang') }}</span>
				<span v-if="scope.row.level == 2">{{ $t('fangkuan') }}</span>
				<span v-if="scope.row.level == 3">{{ $t('jiayan') }}</span>
			</template>

			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" v-if="utils.checkPower('web_quality_management_sampling_create')" @click="yt.showEditDialog('xinzeng', null, 'w1'); setDefaultValue(); getPlanCode()" type="primary">
					{{ $t('xinzeng') }}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<!--				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>-->
			</template>
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('AQL', scope.row, 'w2'); getPlanCode()" v-if="utils.checkPower('web_quality_management_sampling_details_page')">{{ $t('AQL') }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row); getPlanCode()" v-if="utils.checkPower('web_quality_management_sampling_update')">{{ $t('bianji') }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_quality_management_sampling_delete')" @click="yt.remove(scope.row, '/web/quality/sampling/plan/delete')">{{ $t('shanchu') }}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('chouyangfanganbianma')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('chouyangfanganmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/quality/sampling/plan/create')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '抽样方案-新增抽样方案' } }">
						{{ $t('baocun') }}
					</el-button>
				</span>
			</template>
			<!-- 编辑 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder" :label="$t('chouyangfanganbianma')" required>
						<el-input disabled v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('chouyangfanganmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/quality/sampling/plan/update')" type="primary">
						{{ $t('baocun') }}
					</el-button>
				</span>
			</template>
			<template v-if="yt.editObj.action == 'AQL'">
				<div class="dialog-scroller">
					<aql :aql="yt.editObj"></aql>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
import aql from './aql'
export default {
	name: 'web_quality_management_sampling_plan_list',
	components: {
		aql,
	},
	data() {
		return {
			planCodeList: [],
			show: false,
			exceptionTypeList: [],
			columns: [{
				label: 'chouyangfanganbianma',
				prop: 'code',
				width: 150,
			}, {
				label: 'chouyangfanganmingcheng',
				prop: 'name',
				width: 130,
			}, {
				label: 'chuangjianren',
				prop: 'createByObject.nickname',
			}, {
				label: 'chuangjianshijian',
				prop: 'createByObject.createTime',
				type: 'time',
				width: 130,
			},
			{
				label: 'caozuo',
				type: 'slot',
				width: 150,
				fixed: 'right'
			}
			]
		};
	},
	created() {
		setTimeout(() => {
			this.yt.conditions = {
				// orderBy: 'createTime desc,triggerTime asc',
			}
			this.yt.SELECT_URL = "/web/quality/sampling/procedure/listByIds"
			this.yt.SELECT_RESULT_KEY = "data"
			this.yt.SELECT_ID = "id"
			this.yt.SELECT_TITLE = "name"
			this.yt.get(1);
		}, 300)
	},

	methods: {
		getPlanCode() {
			this.http.get('web/quality/sampling/plan/page', {
				params: {
					pageNum: 1,
					pageSize: 1000
				}
			}).then(res => {
				this.planCodeList = res.data.rows
			})
		},
		setDefaultValue() {
			this.yt.editObj.samplingType = 1;
			this.yt.editObj.enabled = true
		},
	}
};
</script>
